import { Role } from '@/type';
import api from '@/API';

export default {
  findAll(accountType: number): Promise<Role[]> {
    return api
      .get('roles', { params: { accountType } })
      .then(response => response.data);
  },
};
